(() => {
  const route = path => (document.body.dataset.root || '/').replace(/\/$/, '') + '/' + path;
  const drawer = document.querySelector('#CartDrawer');
  const announce = message => { document.querySelector('[data-announcer]').textContent = message; };
  const money = (value, currency = document.body.dataset.currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'USD' }).format(value / 100);
  let cartBusy = false, lastOpener;
  const node = (tag, cls, text) => { const el = document.createElement(tag); if (cls) el.className = cls; if (text !== undefined) el.textContent = text; return el; };
  async function api(path, data) {
    const response = await fetch(route(path), data === undefined ? { headers: { Accept: 'application/json' } } : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
    let result; try { result = await response.json(); } catch { throw new Error('Unable to reach the store. Please try again.'); }
    if (!response.ok) {
      const failure = new Error(typeof result.description === 'string' ? result.description : 'The bag could not be updated. Please try again.');
      failure.status = response.status; throw failure;
    }
    return result;
  }
  function openDrawer(opener) {
    if (!drawer?.showModal) { location.href = route('cart'); return; }
    lastOpener = opener || document.activeElement;
    if (!drawer.open) drawer.showModal();
  }
  drawer?.addEventListener('close', () => lastOpener?.focus());
  drawer?.addEventListener('click', event => { if (event.target === drawer) { const rect = drawer.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right) drawer.close(); } });
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const list = drawer.querySelector('[data-cart-items]'); list.replaceChildren();
    drawer.querySelector('[data-cart-summary]').hidden = !cart.item_count;
    drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price, cart.currency);
    if (!cart.item_count) {
      const empty = node('div', 'cart-empty'); empty.append(node('h3', '', 'A little room for comfort.'), node('p', '', 'Your bag is empty. Find your new everyday essential.'));
      const close = node('button', 'button', 'Continue shopping'); close.type = 'button'; close.dataset.dialogClose = ''; empty.append(close); list.append(empty); return;
    }
    for (const item of cart.items) {
      const row = node('article', 'cart-item');
      if (item.image) { const img = node('img'); img.src = item.image; img.alt = item.featured_image?.alt || item.product_title; img.width = 90; img.height = 118; row.append(img); }
      const info = node('div', 'cart-item-info'), heading = node('h3'), link = node('a', '', item.product_title);
      link.href = item.url; heading.append(link); info.append(heading);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(node('p', '', item.variant_title));
      // final_line_price includes line discounts; Ajax line_price can also include
      // cart-wide allocations. Use Shopify's reported amounts, never offer settings.
      const originalTotal = item.original_line_price ?? item.final_line_price;
      let discountedTotal = item.final_line_price;
      if (Number.isSafeInteger(item.line_price)) discountedTotal = Math.min(discountedTotal, item.line_price);
      if (item.discount_allocations?.length) discountedTotal = Math.min(discountedTotal, originalTotal - item.discount_allocations.reduce((total, discount) => total + discount.amount, 0));
      discountedTotal = Math.max(0, discountedTotal);
      const price = node('p', 'cart-item-price');
      if (originalTotal > discountedTotal) {
        price.append(node('span', 'sr-only', 'Original total: '), node('s', 'cart-item-original', money(originalTotal, cart.currency)), node('span', 'sr-only', 'Discounted total: '));
      } else price.append(node('span', 'sr-only', 'Total: '));
      price.append(node('strong', 'cart-item-final', money(discountedTotal, cart.currency)));
      info.append(price);
      if (originalTotal > discountedTotal) info.append(node('p', 'cart-item-savings', 'You save ' + money(originalTotal - discountedTotal, cart.currency)));
      const controls = node('div', 'cart-item-controls'), quantity = node('div', 'quantity-control');
      for (const [label, value, text] of [['Decrease quantity', item.quantity - 1, '−'], ['Increase quantity', item.quantity + 1, '+']]) {
        const button = node('button', '', text); button.type = 'button'; button.setAttribute('aria-label', label + ' for ' + item.product_title); button.dataset.cartKey = item.key; button.dataset.cartQuantity = value;
        if (text === '+') quantity.append(node('span', 'cart-quantity-value', String(item.quantity)));
        quantity.append(button);
      }
      const remove = node('button', 'cart-remove', 'Remove'); remove.type = 'button'; remove.dataset.cartKey = item.key; remove.dataset.cartQuantity = '0';
      controls.append(quantity, remove); info.append(controls); row.append(info); list.append(row);
    }
  }
  async function refreshCart() { const cart = await api('cart.js'); renderCart(cart); return cart; }
  function initCheckout(section, opener) {
    const dialog = section.querySelector('[data-product-checkout-dialog]');
    if (!dialog?.showModal) return null;
    const status = dialog.querySelector('[data-checkout-status]'), error = dialog.querySelector('[data-checkout-error]');
    const content = dialog.querySelector('[data-checkout-content]'), list = dialog.querySelector('[data-checkout-items]');
    const proceed = dialog.querySelector('[data-checkout-continue]'), retry = dialog.querySelector('[data-checkout-retry]');
    const addAgain = dialog.querySelector('[data-checkout-add-again]');
    const receipts = new Map();
    let current, busy = false, checkoutWindow, checkoutSnapshot = '', snapshot = '';
    const windowName = 'comfortCheckout' + Math.random().toString(36).slice(2);
    opener.setAttribute('aria-haspopup', 'dialog'); opener.setAttribute('aria-controls', dialog.id);
    function show() {
      if (!dialog.open) dialog.showModal();
    }
    dialog.querySelectorAll('[data-checkout-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      opener.focus({ preventScroll: true });
    });
    function render(cart) {
      list.replaceChildren();
      for (const item of cart.items) {
        const row = node('li', 'product-checkout-item');
        const image = node(item.image ? 'img' : 'span', 'product-checkout-item-image');
        if (item.image) { image.src = item.image; image.alt = item.featured_image?.alt || item.product_title; image.width = 76; image.height = 96; }
        else image.setAttribute('aria-hidden', 'true');
        const details = node('div', 'product-checkout-item-details');
        details.append(node('h4', 'product-checkout-item-title', item.product_title));
        if (item.variant_title && item.variant_title !== 'Default Title') details.append(node('p', 'product-checkout-item-variant', item.variant_title));
        details.append(node('p', 'product-checkout-item-quantity', 'Quantity: ' + item.quantity));
        const original = item.original_line_price ?? item.final_line_price;
        let final = item.final_line_price;
        if (Number.isSafeInteger(item.line_price)) final = Math.min(final, item.line_price);
        if (item.discount_allocations?.length) final = Math.min(final, original - item.discount_allocations.reduce((sum, discount) => sum + discount.amount, 0));
        const price = node('p', 'product-checkout-item-price');
        if (original > final) price.append(node('span', 'sr-only', 'Original total: '), node('s', '', money(original, cart.currency)));
        price.append(node('span', 'sr-only', 'Total: '), node('strong', '', money(Math.max(0, final), cart.currency)));
        row.append(image, details, price); list.append(row);
      }
      dialog.querySelector('[data-checkout-subtotal]').textContent = money(cart.total_price, cart.currency);
      const originalTotal = cart.original_total_price ?? cart.items.reduce((sum, item) => sum + (item.original_line_price ?? item.final_line_price), 0);
      const savings = Math.max(0, originalTotal - cart.total_price);
      dialog.querySelector('[data-checkout-savings-row]').hidden = savings === 0;
      dialog.querySelector('[data-checkout-savings]').textContent = money(savings, cart.currency);
      snapshot = JSON.stringify([cart.items.map(item => [item.key, item.quantity]), cart.total_price, cart.currency]);
      const receipt = receipts.get(current.signature);
      const changed = receipt?.lines && receipt.lines.some(line => !cart.items.some(item => item.key === line.key && item.quantity === line.quantity));
      const present = current.items.some(wanted => cart.items.some(item => item.id === wanted.id &&
        (wanted.properties?._m_bundle ? item.properties?._m_bundle === wanted.properties._m_bundle : !item.properties?._m_bundle)));
      addAgain.hidden = present;
      content.hidden = !cart.item_count; proceed.disabled = !cart.item_count;
      proceed.querySelector('span').textContent = 'Continue to secure checkout';
      status.textContent = !cart.item_count ? 'Your bag is empty. You can add your selection again.' : receipt?.issue ? 'Review your bag carefully; your full selection may not have been added.' : changed ? 'Your bag has changed. Review the items below before continuing.' : 'Review all items in your bag before continuing.';
    }
    async function loadCart() {
      if (busy) return;
      busy = true; proceed.disabled = true; retry.hidden = true; addAgain.hidden = true; error.textContent = ''; status.textContent = 'Updating your order…';
      dialog.setAttribute('aria-busy', 'true');
      try { render(await refreshCart()); }
      catch (failure) { error.textContent = 'Your bag could not be refreshed. Try again to load the latest order.'; status.textContent = ''; retry.hidden = false; }
      finally { busy = false; dialog.setAttribute('aria-busy', 'false'); }
    }
    retry.addEventListener('click', loadCart);
    async function prepare(signature, items) {
      if (busy) return;
      current = { signature, items: receipts.get(signature)?.items || items };
      show(); busy = true; content.hidden = true; proceed.disabled = true; retry.hidden = true; addAgain.hidden = true; error.textContent = '';
      status.textContent = 'Preparing your order…'; dialog.setAttribute('aria-busy', 'true');
      if (!receipts.has(signature)) {
        // Record attempts before the request: a lost response must never trigger an automatic second add.
        const receipt = { items }; receipts.set(signature, receipt);
        try {
          const added = await api('cart/add.js', { items });
          receipt.lines = (added.items || []).filter(line => items.some(item => item.id === line.id &&
            (item.properties?._m_bundle ? item.properties._m_bundle === line.properties?._m_bundle : !line.properties?._m_bundle)))
            .map(line => ({ key: line.key, quantity: line.quantity }));
        } catch (failure) {
          if (failure.status >= 400 && failure.status < 500) {
            // Shopify can add the available stock and still return 422. Inspect the bag before another add.
            receipt.issue = failure.message; error.textContent = failure.message;
            status.textContent = 'Refresh your bag to review available items, or close checkout to adjust your selection.'; retry.hidden = false;
          } else {
            error.textContent = 'We could not confirm whether your items were added. Refresh your bag before trying again.';
            status.textContent = ''; retry.hidden = false;
          }
          busy = false; dialog.setAttribute('aria-busy', 'false'); return;
        }
      }
      busy = false; await loadCart();
    }
    addAgain.addEventListener('click', () => {
      if (busy) return;
      receipts.delete(current.signature); prepare(current.signature, current.items);
    });
    proceed.addEventListener('click', () => {
      if (busy || proceed.disabled) return;
      if (checkoutWindow && !checkoutWindow.closed && checkoutSnapshot === snapshot) { checkoutWindow.focus(); return; }
      // Open synchronously from the click so browser popup blockers can recognize the gesture.
      checkoutWindow = window.open('', windowName, 'popup,width=1050,height=820,resizable=yes,scrollbars=yes');
      const checkoutForm = node('form'), checkoutInput = node('input');
      checkoutForm.method = 'post'; checkoutForm.action = route('cart'); checkoutForm.hidden = true;
      if (checkoutWindow) checkoutForm.target = windowName;
      checkoutInput.type = 'hidden'; checkoutInput.name = 'checkout'; checkoutInput.value = '1';
      checkoutForm.append(checkoutInput); document.body.append(checkoutForm);
      checkoutForm.submit(); checkoutForm.remove();
      checkoutSnapshot = snapshot;
      status.textContent = checkoutWindow ? 'Secure checkout is open in another window. Complete your order there.' : 'Opening secure checkout in this tab…';
      proceed.querySelector('span').textContent = checkoutWindow ? 'Return to secure checkout' : 'Opening checkout…';
      if (!checkoutWindow) proceed.disabled = true;
    });
    const onFocus = () => { if (dialog.open && !busy) loadCart(); };
    const onPageShow = event => { if (event.persisted && dialog.open) loadCart(); };
    const onUnload = event => {
      if (!event.target.contains(section)) return;
      if (dialog.open) dialog.close();
      window.removeEventListener('focus', onFocus); window.removeEventListener('pageshow', onPageShow);
      document.removeEventListener('shopify:section:unload', onUnload);
    };
    window.addEventListener('focus', onFocus); window.addEventListener('pageshow', onPageShow);
    document.addEventListener('shopify:section:unload', onUnload);
    return {
      prepare,
      restoreFocus() {
        // A request may finish after Escape. Restore focus only if the shopper has not moved it elsewhere.
        if (!dialog.open && (document.activeElement === document.body || dialog.contains(document.activeElement))) opener.focus({ preventScroll: true });
      }
    };
  }
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-dialog-close]')) { drawer.close(); return; }
    const opener = event.target.closest('[data-cart-open]');
    if (opener && drawer?.showModal) { event.preventDefault(); openDrawer(opener); drawer.querySelector('[data-cart-error]').textContent = ''; try { await refreshCart(); } catch (error) { drawer.querySelector('[data-cart-error]').textContent = error.message; } }
    const update = event.target.closest('[data-cart-key]');
    if (update && !cartBusy) {
      cartBusy = true; drawer.querySelector('[data-cart-error]').textContent = '';
      drawer.querySelectorAll('[data-cart-key], [name="checkout"]').forEach(el => el.disabled = true);
      const key = update.dataset.cartKey, direction = update.textContent;
      try {
        const cart = await api('cart/change.js', { id: key, quantity: Number(update.dataset.cartQuantity) }); renderCart(cart); announce('Shopping bag updated. ' + cart.item_count + ' items.');
        ([...drawer.querySelectorAll('[data-cart-key]')].find(el => el.dataset.cartKey === key && el.textContent === direction) || drawer.querySelector('[data-dialog-close]')).focus();
      } catch (error) { drawer.querySelector('[data-cart-error]').textContent = error.message; }
      finally { cartBusy = false; drawer.querySelectorAll('[data-cart-key], [name="checkout"]').forEach(el => el.disabled = false); }
    }
  });
  function initProduct(section) {
    if (section.dataset.ready) return; section.dataset.ready = 'true';
    const form = section.querySelector('.product-form'), select = section.querySelector('[data-variant-select]');
    const variants = JSON.parse(section.querySelector('[data-product-variants]').textContent);
    const options = section.querySelector('[data-variant-options]'), button = section.querySelector('[data-add-button]'), label = section.querySelector('[data-add-label]');
    const buyButton = section.querySelector('[data-buy-now]'), buyLabel = section.querySelector('[data-buy-now-label]');
    const checkout = buyButton ? initCheckout(section, buyButton) : null;
    const quantity = form.querySelector('[name="quantity"]'), error = section.querySelector('[data-product-error]');
    let selected = variants.find(v => String(v.id) === select.value), adding = false, buying = false;
    if (options) { options.hidden = false; section.querySelector('[data-variant-fallback]').hidden = true; }
    const sizeGuide = section.querySelector('[data-size-guide-dialog]');
    if (sizeGuide?.showModal) {
      let guideOpener;
      sizeGuide.querySelector('[data-size-guide-body]').append(section.querySelector('[data-size-guide-content]'));
      section.querySelector('[data-size-guide-fallback]').hidden = true;
      const standalone = section.querySelector('[data-size-guide-standalone]');
      standalone.hidden = Boolean(options?.querySelector('[data-size-guide-open]'));
      section.querySelectorAll('[data-size-guide-open]').forEach(opener => {
        opener.hidden = false;
        opener.addEventListener('click', () => {
          guideOpener = opener;
          if (!sizeGuide.open) sizeGuide.showModal();
        });
      });
      sizeGuide.querySelector('[data-size-guide-close]').addEventListener('click', () => sizeGuide.close());
      sizeGuide.addEventListener('click', event => {
        if (event.target !== sizeGuide) return;
        const rect = sizeGuide.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) sizeGuide.close();
      });
      sizeGuide.addEventListener('close', () => guideOpener?.focus());
    }
    const bundles = section.querySelector('[data-bundle-selector]');
    const optionGroups = [...(options?.querySelectorAll('[data-option-position]') || [])];
    const normalize = value => (value || '').trim().toLowerCase();
    const colorGroup = optionGroups.find(group => normalize(group.dataset.optionName) === normalize(bundles?.dataset.colorOption))
      || optionGroups.find(group => ['color', 'colour'].includes(normalize(group.dataset.optionName)));
    const colorPosition = colorGroup ? Number(colorGroup.dataset.optionPosition) : -1;
    const colors = colorPosition < 0 ? [] : [...new Set(variants.map(variant => variant.options[colorPosition]))];
    const bundleCards = new Map([...(bundles?.querySelectorAll('[data-bundle-card]') || [])].map(card => [Number(card.dataset.bundleCard), card]));
    const bundleRows = new Map();
    let packSize = 1;
    const bundleDiscount = Number(bundles?.dataset.bundleDiscount) || 0;
    function purchasePricing() {
      const inputCount = Number(quantity.value);
      const count = packSize > 1 ? packSize : (Number.isInteger(inputCount) && inputCount > 0 ? inputCount : 1);
      const card = (packSize > 1 || quantity.checkValidity()) && [3, 5].includes(count) ? bundleCards.get(count) : null;
      const price = card ? card.dataset.bundlePrice : !selected ? 'Unavailable' : count === 1 ? selected.price : money(selected.priceCents * count);
      return { count, card, price };
    }
    const chosenOptions = () => optionGroups.map(group => group.querySelector('input:checked')?.value);
    function bundleVariant(color) {
      if (!optionGroups.length) return selected;
      const values = chosenOptions();
      if (colorPosition >= 0) values[colorPosition] = color;
      return variants.find(variant => variant.options.every((value, index) => value === values[index]));
    }
    function createBundleRows(count) {
      if (bundleRows.has(count)) return;
      const rows = [], container = bundleCards.get(count).querySelector('[data-bundle-items]');
      const currentColor = chosenOptions()[colorPosition];
      const initialColor = bundleVariant(currentColor)?.available ? currentColor : colors.find(color => bundleVariant(color)?.available) || currentColor || colors[0];
      for (let index = 0; index < count; index++) {
        const row = node('div', 'bundle-item'), thumbnail = node('div', 'bundle-item-thumbnail');
        thumbnail.setAttribute('aria-hidden', 'true');
        const number = node('span', '', '#' + (index + 1)), img = node('img'); img.alt = ''; img.width = 44; img.height = 54; img.hidden = true;
        thumbnail.append(number, img);
        const control = node('div', 'bundle-item-control'), itemLabel = node('label', '', 'Bra ' + (index + 1) + (colorGroup ? ' · ' + colorGroup.dataset.optionName : ''));
        const input = colors.length ? node('select') : node('p', 'bundle-item-option');
        input.id = 'BundleColor-' + form.id + '-' + count + '-' + index;
        if (colors.length) {
          itemLabel.htmlFor = input.id;
          colors.forEach(color => { const option = node('option', '', color); option.value = color; input.append(option); });
          input.value = initialColor;
          input.required = true;
          input.addEventListener('change', () => { error.textContent = ''; updatePurchaseState(); });
        }
        control.append(itemLabel, input); row.append(thumbnail, control); container.append(row);
        rows.push({ input, img, number });
      }
      bundleRows.set(count, rows);
    }
    function bundleSelection() {
      const items = new Map();
      for (const [index, row] of bundleRows.get(packSize).entries()) {
        const variant = bundleVariant(colors.length ? row.input.value : null);
        if (!variant?.available) return { items: [], message: 'Bra ' + (index + 1) + ': choose an available ' + (colors.length ? 'color for the selected size/options.' : 'option.') };
        const item = items.get(variant.id) || { id: variant.id, quantity: 0 }; item.quantity++; items.set(variant.id, item);
      }
      for (const item of items.values()) {
        const variant = variants.find(variant => variant.id === item.id);
        if (item.quantity < variant.min || (item.quantity - variant.min) % variant.step || (variant.max && item.quantity > variant.max)) {
          return { items: [], message: variant.options.join(' / ') + ' cannot be ordered in this quantity. Please adjust your bundle colors.' };
        }
      }
      return { items: [...items.values()], message: '' };
    }
    function updatePurchaseState() {
      const isBundle = packSize > 1;
      if (colorGroup) colorGroup.hidden = isBundle;
      quantity.closest('.quantity-control').hidden = isBundle;
      section.querySelector('.quantity-label').hidden = isBundle;
      quantity.disabled = isBundle || adding;
      section.querySelectorAll('[data-quantity-change]').forEach(control => control.disabled = adding);
      const pricing = purchasePricing();
      const compare = section.querySelector('[data-compare-price]');
      const singlePrice = bundles?.querySelector('[data-single-bundle-price]');
      if (singlePrice) {
        const singleCount = isBundle ? 1 : pricing.count;
        singlePrice.textContent = isBundle ? selected?.price || 'Unavailable' : pricing.price;
        bundles.querySelector('[data-quantity-card-title]').textContent = singleCount === 1 ? '1 Bra' : singleCount + ' Bras';
        bundles.querySelector('[data-quantity-card-note]').textContent = singleCount === 1 ? 'Standard price' : 'Same color' + (pricing.card && bundleDiscount > 0 ? ' · ' + bundleDiscount + '% off' : '');
      }
      if (isBundle) createBundleRows(packSize);
      bundleCards.forEach((card, count) => {
        card.classList.toggle('is-selected', count === packSize);
        const content = card.querySelector('[data-bundle-content]');
        if (content) content.hidden = count !== packSize;
        card.querySelectorAll('select').forEach(input => input.disabled = count !== packSize);
      });
      if (bundles) bundles.disabled = adding;
      if (isBundle) {
        const card = bundleCards.get(packSize);
        const sharedOptions = optionGroups.filter(group => group !== colorGroup).map(group => group.dataset.optionName + ': ' + group.querySelector('input:checked')?.value).join(' · ');
        card.querySelector('[data-bundle-color-note]').textContent = (colors.length ? 'Choose a color for each bra. ' : '') + (sharedOptions ? 'All bras use ' + sharedOptions + '.' : 'Includes ' + packSize + ' bras.');
        for (const row of bundleRows.get(packSize)) {
          const variant = bundleVariant(colors.length ? row.input.value : null);
          if (colors.length) {
            for (const option of row.input.options) {
              const match = bundleVariant(option.value);
              option.disabled = !match?.available;
              option.textContent = option.value + (!match ? ' — Unavailable' : !match.available ? ' — Sold out' : '');
            }
            row.input.setAttribute('aria-invalid', String(!variant?.available));
            row.input.setCustomValidity(variant?.available ? '' : 'Choose an available color for the selected size/options.');
          } else row.input.textContent = variant?.options.join(' / ') || 'Unavailable';
          row.img.hidden = !variant?.image; row.number.hidden = Boolean(variant?.image);
          if (variant?.image && row.img.getAttribute('src') !== variant.image) row.img.src = variant.image;
        }
        const selection = bundleSelection();
        card.querySelector('[data-bundle-error]').textContent = selection.message;
        button.disabled = adding || Boolean(selection.message);
        label.textContent = adding ? 'Adding…' : selection.message ? 'Check bundle options' : 'Add ' + packSize + '-pack to bag';
        section.querySelector('[data-variant-status]').textContent = '';
      } else {
        button.disabled = !selected?.available || adding || !quantity.checkValidity();
        label.textContent = adding ? 'Adding…' : !selected ? 'Unavailable' : selected.available ? 'Add to bag' : 'Sold out';
        section.querySelector('[data-variant-status]').textContent = !selected ? 'This combination is not available. Please choose another option.' : !selected.available ? 'This option is currently sold out.' : '';
      }
      if (buyButton) {
        buyButton.disabled = button.disabled;
        buyButton.setAttribute('aria-busy', String(adding && buying));
        buyLabel.textContent = adding ? buying ? 'Preparing checkout…' : 'Please wait…' : 'Buy now';
      }
      section.querySelector('[data-product-price]').textContent = pricing.price;
      const comparePrice = pricing.card ? (bundleDiscount > 0 ? pricing.card.dataset.bundleCompare : '') : pricing.count === 1 ? selected?.compare : '';
      compare.hidden = !comparePrice; compare.textContent = comparePrice || '';
      const summary = section.querySelector('[data-purchase-summary]');
      if (summary) {
        summary.hidden = !selected && !isBundle;
        summary.querySelector('[data-purchase-summary-label]').textContent = 'Total for ' + pricing.count + (pricing.count === 1 ? ' bra' : ' bras');
        summary.querySelector('[data-purchase-total]').textContent = pricing.price;
        summary.querySelector('[data-purchase-discount]').textContent = pricing.card && bundleDiscount > 0 ? bundleDiscount + '% bundle discount included' : '';
      }
      const heading = section.querySelector('[data-purchase-heading]');
      if (heading) heading.textContent = 'THE EVERYDAY EDIT · ' + (pricing.card ? pricing.count + ' BRA PACK' : pricing.count === 1 ? '1 PIECE' : pricing.count + ' BRAS');
    }
    if (bundles) {
      bundles.hidden = false;
      bundles.querySelectorAll('[data-bundle-choice]').forEach(input => input.addEventListener('change', () => {
        packSize = Number(input.value); error.textContent = ''; updatePurchaseState();
      }));
    }
    function setImage(url, alt) {
      if (!url) return;
      const img = section.querySelector('[data-main-image] img'); img.src = url; img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.alt = alt || img.alt;
      section.querySelectorAll('[data-gallery-image]').forEach(el => { const active = el.dataset.galleryImage === url; el.classList.toggle('is-active', active); el.setAttribute('aria-pressed', String(active)); });
    }
    function chooseVariant() {
      if (options) {
        const values = [...options.querySelectorAll('fieldset')].map(group => group.querySelector('input:checked')?.value);
        selected = variants.find(v => v.options.every((value, i) => value === values[i]));
        options.querySelectorAll('fieldset').forEach(group => { group.querySelector('[data-option-value]').textContent = group.querySelector('input:checked')?.value || ''; });
      } else selected = variants.find(v => String(v.id) === select.value);
      select.disabled = !selected; if (selected) select.value = selected.id;
      error.textContent = '';
      if (selected) {
        quantity.min = selected.min; quantity.step = selected.step;
        if (selected.max) quantity.max = selected.max; else quantity.removeAttribute('max');
        const next = Math.max(selected.min, Math.min(selected.max || Infinity, Number(quantity.value) || selected.min));
        quantity.value = selected.min + Math.floor((next - selected.min) / selected.step) * selected.step;
        setImage(selected.image, selected.imageAlt);
      }
      const url = new URL(location.href); if (selected) url.searchParams.set('variant', selected.id); else url.searchParams.delete('variant'); history.replaceState({}, '', url);
      updatePurchaseState();
    }
    options?.addEventListener('change', chooseVariant); select.addEventListener('change', chooseVariant);
    section.querySelectorAll('[data-gallery-image]').forEach(el => el.addEventListener('click', () => setImage(el.dataset.galleryImage, el.dataset.galleryAlt)));
    section.querySelectorAll('[data-quantity-change]').forEach(el => el.addEventListener('click', () => { const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1, max = quantity.max ? Number(quantity.max) : Infinity; quantity.value = Math.max(min, Math.min(max, (Number(quantity.value) || min) + Number(el.dataset.quantityChange) * step)); quantity.dispatchEvent(new Event('change')); }));
    for (const event of ['input', 'change']) quantity.addEventListener(event, () => { error.textContent = ''; updatePurchaseState(); });
    form.addEventListener('submit', async event => {
      const buyNow = Boolean(buyButton && event.submitter === buyButton);
      const pricing = purchasePricing();
      if (!buyNow && !drawer?.showModal && packSize === 1 && !pricing.card) return; event.preventDefault();
      const selection = packSize > 1 ? bundleSelection() : { items: [{ id: selected?.id, quantity: Number(quantity.value) }], message: selected?.available ? '' : 'Choose an available option.' };
      if (adding || selection.message || !form.reportValidity()) return;
      adding = true; buying = buyNow; updatePurchaseState(); error.textContent = '';
      let checkoutPending = false;
      try {
        const groupId = pricing.card ? (window.crypto?.randomUUID?.() || Date.now().toString(36) + '-' + Math.random().toString(36).slice(2)) : null;
        const items = selection.items.map(item => groupId ? { ...item, properties: { _m_bundle: groupId, _m_bundle_size: String(pricing.count) } } : item);
        if (buyNow && checkout) {
          const signature = JSON.stringify([pricing.count, [...selection.items].sort((a, b) => a.id - b.id)]);
          await checkout.prepare(signature, items); return;
        }
        await api('cart/add.js', { items });
        if (buyNow) {
          // Use the same cart checkout submission as Shopify's native checkout button.
          const checkoutForm = document.createElement('form'), checkoutInput = document.createElement('input');
          checkoutForm.method = 'post'; checkoutForm.action = route('cart'); checkoutForm.hidden = true;
          checkoutInput.type = 'hidden'; checkoutInput.name = 'checkout'; checkoutInput.value = '1';
          checkoutForm.append(checkoutInput); document.body.append(checkoutForm);
          checkoutForm.submit(); checkoutPending = true;
          return;
        }
        if (!drawer?.showModal) { location.href = route('cart'); return; }
        announce('Added to your shopping bag.'); openDrawer(button); drawer.querySelector('[data-cart-error]').textContent = '';
        try { await refreshCart(); } catch { drawer.querySelector('[data-cart-error]').textContent = 'Your item was added, but the bag could not refresh. Reopen your bag to see it.'; }
      } catch (failure) { error.textContent = failure.message; }
      finally {
        if (!checkoutPending) {
          adding = false; buying = false; updatePurchaseState();
          if (buyNow && checkout) checkout.restoreFocus();
        }
      }
    });
    updatePurchaseState();
    if (buyButton) buyButton.hidden = false;
    window.addEventListener('pageshow', event => {
      if (event.persisted) { adding = false; buying = false; updatePurchaseState(); }
    });
  }
  document.querySelectorAll('[data-product-section]').forEach(initProduct);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-product-section]').forEach(initProduct));
})();
